import { i18n } from "@/plugins/vue-i18n";
import HelpYoutubePlayer from "@/components/help/HelpYoutubePlayer.vue";

export const onboardings = {
  installExtension: {
    custom: true,
    title: i18n.t("guide.stepsOnboarding.installExtension.title"),
    description: i18n.t("guide.stepsOnboarding.installExtension.description"),
    onboardingName: "installExtension",
    onboarding_code: "install_extension",
    buttonUrl: `https://workspace.google.com/marketplace/app/conecta_suite/${process.env.VUE_APP_MARKETPLACE_APP_ID}`,
    steps: [
      {
        is: "b",
        inner: i18n.t(
          "guide.stepsOnboarding.installExtension.videoTopicsTitle"
        ),
      },
      {
        is: "ul",
        elements: [
          {
            is: "li",
            inner: i18n.t(
              "guide.stepsOnboarding.installExtension.videoTopics1"
            ),
          },
          {
            is: "li",
            inner: i18n.t(
              "guide.stepsOnboarding.installExtension.videoTopics2"
            ),
          },
        ],
      },
      {
        is: HelpYoutubePlayer,
        bind: {
          videoId: "ZP320jg0TbQ",
          isOnboarding: true,
        },
      },
    ],
  },
  applySignature: {
    custom: true,
    title: i18n.t("guide.stepsOnboarding.applySignature.title"),
    description: i18n.t("guide.stepsOnboarding.applySignature.description"),
    onboardingName: "applySignature",
    onboarding_code: "email_signature",
    nextRouteName: "SignTemplates",
    steps: [
      {
        is: "b",
        inner: i18n.t("guide.stepsOnboarding.applySignature.videoTopicsTitle"),
      },
      {
        is: "ul",
        elements: [
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.applySignature.videoTopics1"),
          },
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.applySignature.videoTopics2"),
          },
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.applySignature.videoTopics3"),
          },
        ],
      },
      {
        is: HelpYoutubePlayer,
        bind: {
          videoId: "ZXsUZ56p678",
          isOnboarding: true,
        },
      },
    ],
  },
  emailDelegation: {
    custom: true,
    title: i18n.t("guide.stepsOnboarding.emailDelegation.title"),
    description: i18n.t("guide.stepsOnboarding.emailDelegation.description"),
    onboardingName: "emailDelegation",
    onboarding_code: "email_delegation",
    nextRouteName: "User",
    steps: [
      {
        is: "b",
        inner: i18n.t("guide.stepsOnboarding.emailDelegation.videoTopicsTitle"),
      },
      {
        is: "ul",
        elements: [
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.emailDelegation.videoTopics1"),
          },
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.emailDelegation.videoTopics2"),
          },
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.emailDelegation.videoTopics3"),
          },
        ],
      },
      {
        is: HelpYoutubePlayer,
        bind: {
          videoId: "mD4Ecma1dzs",
          isOnboarding: true,
        },
      },
    ],
  },
  aliasEmail: {
    custom: true,
    title: i18n.t("guide.stepsOnboarding.aliasEmail.title"),
    description: i18n.t("guide.stepsOnboarding.aliasEmail.description"),
    onboardingName: "aliasEmail",
    onboarding_code: "email_aliases",
    nextRouteName: "User",
    steps: [
      {
        is: "b",
        inner: i18n.t("guide.stepsOnboarding.aliasEmail.videoTopicsTitle"),
      },
      {
        is: "ul",
        elements: [
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.aliasEmail.videoTopics1"),
          },
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.aliasEmail.videoTopics2"),
          },
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.aliasEmail.videoTopics3"),
          },
        ],
      },
      {
        is: HelpYoutubePlayer,
        bind: {
          videoId: "35N2I5X9q-k",
          isOnboarding: true,
        },
      },
    ],
  },
  secondaryEmail: {
    custom: true,
    title: i18n.t("guide.stepsOnboarding.secondaryEmail.title"),
    description: i18n.t("guide.stepsOnboarding.secondaryEmail.description"),
    onboardingName: "secondaryEmail",
    onboarding_code: "secondary_emails",
    nextRouteName: "User",
    steps: [
      {
        is: "b",
        inner: i18n.t("guide.stepsOnboarding.secondaryEmail.videoTopicsTitle"),
      },
      {
        is: "ul",
        elements: [
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.secondaryEmail.videoTopics1"),
          },
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.secondaryEmail.videoTopics2"),
          },
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.secondaryEmail.videoTopics3"),
          },
        ],
      },
      {
        is: HelpYoutubePlayer,
        bind: {
          videoId: "UTQinkCGKA0",
          isOnboarding: true,
        },
      },
    ],
  },
  driveSharing: {
    custom: true,
    title: i18n.t("guide.stepsOnboarding.driveSharing.title"),
    description: i18n.t("guide.stepsOnboarding.driveSharing.description"),
    onboardingName: "driveSharing",
    onboarding_code: "drive_sharing",
    nextRouteName: "User",
    steps: [
      {
        is: "b",
        inner: i18n.t("guide.stepsOnboarding.driveSharing.videoTopicsTitle"),
      },
      {
        is: "ul",
        elements: [
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.driveSharing.videoTopics1"),
          },
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.driveSharing.videoTopics2"),
          },
          {
            is: "li",
            inner: i18n.t("guide.stepsOnboarding.driveSharing.videoTopics3"),
          },
        ],
      },
      {
        is: HelpYoutubePlayer,
        bind: {
          videoId: "YOgs5IgAEZE",
          isOnboarding: true,
        },
      },
    ],
  },
};
